import React, { useContext } from "react";
import classNames from "classnames";
import { Button } from "@cmsgov/ds-medicare-gov";
import { PreviewContext, sendTealiumEvent } from "../../../helpers";
import { createGa4Event, Ga4Event } from "../../../helpers/analytics";
import { useFlags } from "launchdarkly-react-client-sdk";
import { AppContext } from "../../../app/store";

export const ToggleMoreBenefits: React.FunctionComponent<{
  buttonTextToCollapse: string;
  buttonTextToOpen: string;
  children: React.ReactNode;
  section: string;
}> = ({ buttonTextToCollapse, buttonTextToOpen, children, section }) => {
  const previewMode = useContext(PreviewContext);
  const flags = useFlags();
  const { state } = useContext(AppContext);
  const [isOpen, setIsOpen] = React.useState(false);

  return previewMode ? (
    <div>{children}</div>
  ) : (
    <>
      <Button
        className="ds-c-button--primary-alt ds-l-col--12 ds-u-margin-top--4 ds-u-padding-y--3 mct-hide-print"
        onClick={() => {
          setIsOpen(!isOpen);
          if (!isOpen) {
            sendTealiumEvent("Plan Details view more", `${section}|expand`);
            createGa4Event({
              event_name: Ga4Event.PLAN_DETAILS_VIEW_MORE_EXPANDED,
              click_text: buttonTextToOpen,
              state,
              flags,
            });
          } else {
            sendTealiumEvent("Plan Details view more", `${section}|close`);
            createGa4Event({
              event_name: Ga4Event.PLAN_DETAILS_VIEW_MORE_CLOSED,
              click_text: buttonTextToCollapse,
              state,
              flags,
            });
          }
        }}
        aria-expanded={isOpen}
      >
        <i
          className={classNames(
            "ds-u-margin-right--1 fas",
            { "fa-plus": !isOpen },
            { "fa-minus": isOpen }
          )}
        />
        {isOpen ? buttonTextToCollapse : buttonTextToOpen}
      </Button>
      <div
        className={classNames(
          "PlanDetailsSection__collapse-container",
          isOpen
            ? "PlanDetailsSection__collapse-container--expanded"
            : "PlanDetailsSection__collapse-container--collapsed"
        )}
      >
        {children}
      </div>
    </>
  );
};
